import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { Store } from '../../Store';

export default function ProtectedRoute({ children }) {
  const { state } = useContext(Store);
  const { userInfo } = state;
  return userInfo ? children : <Navigate to="/signin" />;
} // this function is a wrapper for other Route components (in the App.js file). Before routing to a screen that is wrapped by this function, it checks if the user is signed in and only than allows the user to access this route
